import React from 'react';
import Video from '../platformui/Video';
import * as Render from '../platformui/Base/Render';

export default (props) => {
  const { CurrentPageProps: {
    DisableVideoBlockText = false
  } } = props;

  return <Video
    {...props}
    VideoText={Render.Property(props.VideoText, 'VideoText')}
    hideCaption={DisableVideoBlockText}
    hideTitle={DisableVideoBlockText}
  />;
}
